import client from "./client";

export default {

    async getVisitors(filters) {
        return client.parseResponse(await client.get('/visitors', filters));
    },

    async checkoutVisitor(filters) {
        return client.parseResponse(await client.post('/checkout-visitor', filters));
    },

    async sendOTP(filters) {
        return client.parseResponse(await client.post('/visitor-otp', filters));
    },

    async approveVisitorCheckin(filters) {
        return client.parseResponse(await client.post('/approve-visitor-checkin', filters));
    },
    async verifyTenantApproval(filters) {
        return client.parseResponse(await client.post('/verify-tenant-approval', filters));
    },

    async verifyVisitorOtp(filters) {
        return client.parseResponse(await client.post('/verify-visitor-otp', filters));
    },

    async sendTenantOTP(filters) {
        return client.parseResponse(await client.post('/tenant-otp', filters));
    },

    async createVisitor(data) {
        return client.parseResponse(await client.post('/visitors', data))
    },

    async createVisitors(data) {
        return client.parseResponse(await client.post('visitors', data))
    },

    async getVisitor(id) {
        return client.parseResponse(await client.get('/visitors/' + id));
    },

    async editVisitor(data) {
        return client.parseResponse(await client.put('/visitors/' + data.id, data))
    },

    async editVisitorFormData(data) {
        return client.parseResponse(await client.post('/visitors/' + data.get('id') + "?_method=PUT", data, {
            contentType: 'application/x-www-form-urlencoded'
        }))
    },

    async deleteVisitor(data) {
        return client.parseResponse(await client.delete('/visitors/' + data.id, data))
    },

    async downloadVisitorHistory(filters) {
        return client.parseResponse(await client.get('/download-visitors', filters, {responseType: 'blob'}))
    },

    async exportVisitorsReport(filters) {
        return client.parseResponse(await client.get('/export-visitors', filters, {responseType: 'blob'}));
    }
}
